export default "/images/vendor/flag-icon-css/flags/1x1/cr.svg?ebed46008265a3777565bf8c24dd3bda";